import { Component, OnInit, Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RestService } from '../../master-services/Rest/rest.service';
import {
  NgbDateParserFormatter,
  NgbDatepickerI18n,
  NgbDateStruct,
} from "@ng-bootstrap/ng-bootstrap";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
const EXCEL_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const EXCEL_EXTENSION = ".xlsx";


import swal from 'sweetalert2';
import { Router } from '@angular/router';




@Injectable()
export class I18n {
  language = "fr";
}

interface bussnessInterface {
  // item para mostrar clientes
  id?: number;
  business_name?: string;
  type_document_id?: number;
}

interface typeMaintenanceInterface {
  // item para mostrar tipo mantenimiento
  id?: number;
  business_name?: string;
  type_document_id?: number;
}

interface statusMaintenanceInterface {
  // item para mostrar estado
  id?: number;
  business_name?: string;
  type_document_id?: number;
}

interface busnessOfficeInterface {
  // item para mostrar clientes
  department?: string;
  description?: string;
}

interface officeInterface {
  // item para mostrar sedes
  id?: number;
  name?: string;
  select?: boolean;
}


interface tableInterface {
  business_name?: string;
  document?: string;
  document_id?: string;
  telephone?: string;
  email?: string;
  price_margin?: string;
  Condicion_de_pago?: string;
  name?: string;
  cellphone?: string;
  department?: string;
  city?: string;
  create_at?: string;
}




@Component({
  selector: 'app-master-customers',
  templateUrl: './master-customers.component.html',
  styleUrls: ['./master-customers.component.scss',
    '../../../assets/icon/icofont/css/icofont.scss']
})




export class MasterCustomersComponent implements OnInit {


  myForm: FormGroup;
  myFormUpdate: FormGroup;
  submitted = false;
  rowsClient: any;
  rowsTemp: any;
  rowStatic: any;
  rows: any;
  a: any = 5;
  kilo: any;
  elementDelete: any;
  status: number = 3;
  switchCreate = true;
  switchUpdate = true;
  change = true;
  active = false;
  inactive = false;
  enabledUpdated = false;

  filterIndicatorText = false;
  filterIndicatorCheck = false;

  rowsTempCheck: any;
  rowsTempText: any;
  // dataExcels: Array<tableInterface> = [];
  currentBrand: any;
  dataExcels: Array<tableInterface> = [];
  dataExcel: tableInterface;

  userId: number = 0;
  profileType: number = 0;

  filtersExpanded = false;

  departments: any;
  cities: any;
  customerTypes: any;
  customerOrigins: any;
  regionals: any;

  selectedDepartmentId: number = 0;
  selectedCityId: number = 0;
  selectedCustomerTypeId: number = 0;
  selectedCustomerOriginId: number = 0;
  selectedRegionalId: number = 0;
  selectedUserAdvisorId: number = 0;

  userAdvisors: { id: number, name: string }[] = [];

  fromCreateAt: NgbDateStruct;
  toCreateAt: NgbDateStruct;

  constructor(private restService: RestService, private router: Router) {
    this.userId = Number(localStorage.getItem("userid"));
    this.profileType = Number(localStorage.getItem("profile"));

    // if (
    //   Number(localStorage.getItem("profile")) == 2 ||
    //   Number(localStorage.getItem("profile")) == 3
    // ) {
    //   this.getCustomerForAdvisor(Number(localStorage.getItem("userid")));
    // } else {
      this.loadingData();
    // }

    const description = new FormControl('', Validators.required);
    const descriptionUpdate = new FormControl('', Validators.required);


    this.myForm = new FormGroup({
      description: description
    });

    this.myFormUpdate = new FormGroup({
      descriptionUpdate: descriptionUpdate
    });
  }














  loadingData() {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    this.restService.getCustomer().then(data => {
      const resp: any = data;
      swal.close();
      this.rowsClient = resp.data;
      this.rowStatic = resp.data;
      this.rowsTemp = resp.data;
    }).catch(error => {
      console.log(error);
    });

    this.getDepartments();
    this.getAllCustomerTypes();
    this.getAllCustomerOrigins();
    this.getRegionals();
    this.getAllUserAdvisors();
  }

  getDepartments() {
    this.restService.getDepartments().then(data => {
      const resp: any = data;
      this.departments = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  getCities() {
    this.restService.getCities(Number(this.selectedDepartmentId)).then(data => {
      const resp: any = data;
      this.cities = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  getAllUserAdvisors() {
    this.restService.getUsersAdvisors()
      .subscribe(
        data => {
          const resp: any = data;
          this.userAdvisors = resp.data;
          console.log('userAdvisors: ', this.userAdvisors);
        },
        error => {
          console.log('getAllUserAdvisors error: ', error);
        }
      )
  }

  getAllCustomerTypes() {
    this.restService.getAllCustomerTypes().then(data => {
      const resp: any = data;
      this.customerTypes = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  getAllCustomerOrigins() {
    this.restService.getAllCustomerOrigins().then(data => {
      const resp: any = data;
      this.customerOrigins = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  getRegionals() {
    this.restService.getRegional().then(data => {
      const resp: any = data;
      this.regionals = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  toggleFilters() {
    this.filtersExpanded = !this.filtersExpanded;
  }

  clearFilters() {
    this.fromCreateAt = null;
    this.toCreateAt = null;
    this.selectedDepartmentId = 0;
    this.selectedCityId = 0;
    this.cities = null;
    this.selectedCustomerTypeId = 0;
    this.selectedCustomerOriginId = 0;
    this.selectedRegionalId = 0;
    this.selectedUserAdvisorId = 0;
  }

  getCustomerForAdvisor(id: any) {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    this.restService
      .getCustomersForAdvisor(id)
      .subscribe(
        data => {
          const resp: any = data;
          swal.close();
          this.rowsClient = resp.data;
          this.rowStatic = resp.data;
          this.rowsTemp = resp.data;
        },
        error => {
          console.log(error);
        }
      );
  }


  getCotmerStatus(status: number) {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    this.restService.getCotmerStatus(status).then(data => {
      const resp: any = data;
      swal.close();
      this.rowsClient = resp.data;
      this.rowStatic = resp.data;
      this.rowsTemp = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }

  filter(description: any) {
    this.restService.filter(description).then(data => {
      const resp: any = data;
      swal.close();
      this.rowsClient = resp.data;
      this.rowStatic = resp.data;
      this.rowsTemp = resp.data;
    }).catch(error => {
      console.log(error);
    });
  }


  updateFilter(event) {
    const val = event.target.value.toLowerCase();
    this.filter(val);
  }


  updateFilterActiveInactive(active: string) {

  }


  onChangeCreate(check: any) {
    this.change = check;
  }

  onChangeUpdate(check: any) {
    this.switchUpdate = check;
    this.enabledUpdated = check;

  }






  excelCutomer() {

    this.restService
      .getMaintenanceSettlement(this.status)
      .then((data) => {
        const resp: any = data;

        this.rowsClient = resp.data;
        for (let data of resp.data) {
          this.dataExcel = {
            business_name: data.business_name,
            document: data.document,
            document_id: data.document_id,
            telephone: data.telephone,
            email: data.email,
            price_margin: data.price_margin,
            Condicion_de_pago: data.pcodescription,
            name: data.name,
            cellphone: data.cellphone,
            department: data.department,
            city: data.city,
            create_at: data.create_at,
          };
          this.dataExcels.push(this.dataExcel);
        }
        this.dataExcels.push(this.dataExcel);

        this.exportAsExcelFile(
          this.dataExcels,
          "Clientes"
        );
        swal.close();

        if (resp.error) {
          swal({
            title: "Oops",
            text: "Hubo un error en la consulta.",
            type: "error",
          });
        }
        if (this.rowsClient.length == 0) {
          swal({
            title: "Oops",
            text: "No hay resultado en la consulta.",
            type: "error",
          });
        }

      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "Oops",
          text: "Hubo un error en la consulta.",
          type: "error",
        });
      });

  }


  formatDatePart(value: number): string {
    return value < 10 ? "0" + value : "" + value;
  }

  formatNgbDate(date: NgbDateStruct): string {
    if (!date) {
      return null;
    }
    return date.year + "-" + this.formatDatePart(date.month) + "-" + this.formatDatePart(date.day);
  }

  exportCustomers() {
    swal({
      title: 'Generando informe ...',
      allowOutsideClick: false
    });
    swal.showLoading();

    const filters = {
      from_create_at: this.formatNgbDate(this.fromCreateAt),
      to_create_at: this.formatNgbDate(this.toCreateAt),
      department_id: this.selectedDepartmentId ? this.selectedDepartmentId : undefined,
      city_id: this.selectedCityId ? this.selectedCityId : undefined,
      customer_type_id: this.selectedCustomerTypeId ? this.selectedCustomerTypeId : undefined,
      origin_id: this.selectedCustomerOriginId ? this.selectedCustomerOriginId : undefined,
      regional_id: this.selectedRegionalId ? this.selectedRegionalId : undefined,
      customer_advisor: this.selectedUserAdvisorId ? this.selectedUserAdvisorId : undefined,
    };

    this.restService.getCustomersFilteredExcel(filters).then(data => {
      const resp: any = data;
      swal.close();

      if (resp && resp.success === false) {
        swal({
          title: 'Error',
          text: resp.message || 'Hubo un error en la consulta.',
          type: 'error'
        });
        return;
      }

      const customers: any[] = (resp && resp.data) ? resp.data : [];

      if (customers.length === 0) {
        swal({
          title: 'Sin resultados',
          text: 'No hay clientes que coincidan con los filtros seleccionados.',
          type: 'info'
        });
        return;
      }

      const rowsForExcel: any[] = [];

      for (const customer of customers) {
        const baseRow = {
          business_name: customer.business_name,
          document_id: customer.document_id,
          status: customer.status,
          department: customer.department_id ? customer.department_id.name : '',
          city: customer.city_id ? customer.city_id.name : '',
          customer_type: customer.customer_type_id ? customer.customer_type_id.name : '',
          comercial_email: customer.comercial_email || '',
          origin: customer.origin_id ? customer.origin_id.name : '',
        };

        const regionals: any[] = customer.regionals || [];
        const contacts: any[] = customer.contacts || [];
        const advisors: any[] = customer.advisors || [];

        const fallbackEmail = contacts.length === 0 ? (customer.email || '') : '';

        if (regionals.length === 0 && contacts.length === 0) {
          rowsForExcel.push(Object.assign({}, baseRow,
            this.regionalCols(null),
            this.contactCols(null, fallbackEmail),
            this.advisorCols(advisors, null)));
          continue;
        }

        const usedContactIds: any[] = [];

        for (const regional of regionals) {
          const regionalContacts = contacts.filter(
            (c: any) => String(c.regional_id) === String(regional.id)
          );
          const advisorColumns = this.advisorCols(advisors, regional.id);

          if (regionalContacts.length === 0) {
            rowsForExcel.push(Object.assign({}, baseRow,
              this.regionalCols(regional),
              this.contactCols(null, fallbackEmail),
              advisorColumns));
          } else {
            for (const contact of regionalContacts) {
              usedContactIds.push(contact.id);
              rowsForExcel.push(Object.assign({}, baseRow,
                this.regionalCols(regional),
                this.contactCols(contact, ''),
                advisorColumns));
            }
          }
        }

        const orphanContacts = contacts.filter((c: any) => usedContactIds.indexOf(c.id) === -1);
        for (const contact of orphanContacts) {
          rowsForExcel.push(Object.assign({}, baseRow,
            this.regionalCols(null),
            this.contactCols(contact, ''),
            this.advisorCols(advisors, contact.regional_id)));
        }
      }

      this.exportAsExcelFile(rowsForExcel, 'Clientes', 'Clientes');
    }).catch(error => {
      console.log(error);
      swal.close();
      swal({
        title: 'Oops',
        text: 'Hubo un error en la consulta.',
        type: 'error'
      });
    });
  }

  regionalCols(regional: any) {
    return {
      regional: regional ? (regional.description || '') : '',
    };
  }

  contactCols(contact: any, fallbackEmail: string) {
    return {
      contact_name: contact ? (contact.name || '') : '',
      contact_email: contact ? (contact.email || '') : (fallbackEmail || ''),
      contact_telephone: contact ? (contact.telephone || '') : '',
    };
  }

  advisorCols(advisors: any[], regionalId: any) {
    const list: any[] = (regionalId === null || regionalId === undefined)
      ? []
      : (advisors || []).filter((a: any) => String(a.regional_id) === String(regionalId));

    const advisor1 = list[0];
    const advisor2 = list[1];

    return {
      advisor_1_name: advisor1 ? (advisor1.name || '') : '',
      advisor_1_email: advisor1 ? (advisor1.email || '') : '',
      advisor_2_name: advisor2 ? (advisor2.name || '') : '',
      advisor_2_email: advisor2 ? (advisor2.email || '') : '',
    };
  }

  public exportAsExcelFile(rows: any[], excelFileName: string, sheetName: string = "Info-Controles-Liquidados"): void {
    if (rows.length > 0) {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rows);
      const workbook: XLSX.WorkBook = {
        Sheets: { [sheetName]: worksheet },
        SheetNames: [sheetName],
      };
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, excelFileName);
    } else {
      swal({
        title: "Error",
        text: "Ha ocurrido un error",
        type: "error",
      });
    }
  }



  private saveAsExcelFile(buffer: any, baseFileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, baseFileName + EXCEL_EXTENSION);
    swal.close();
    this.dataExcels.length = 0;
  }



  onChangeActive(d) {
    let indice;
    if (this.active === false) {
      this.active = true;

      if (this.inactive === true) {
        this.loadingData();
        this.status = 3;

      } else {
        this.status = 1;
        this.getCotmerStatus(0);
      }
      this.updateFilterActiveInactive(indice);
    } else {
      this.active = false;
      if (this.inactive === true) {
        this.status = 1;
        this.getCotmerStatus(0)
      } else {
        this.loadingData();
        this.status = 3;

      }
      this.updateFilterActiveInactive(indice);
    }
  }


  onChangeInactive(d) {
    let indice;
    this.status = 0;

    if (this.inactive === false) {
      this.inactive = true;
      if (this.active === true) {
        this.loadingData()
      } else {
        this.status = 0;
        this.getCotmerStatus(1);
      }
      this.updateFilterActiveInactive(indice);
    } else {
      this.inactive = false;
      if (this.active === true) {
        this.status = 1;
        this.getCotmerStatus(0);
      } else {
        this.status = 3;
        this.loadingData();

      }
      this.updateFilterActiveInactive(indice);
    }
  }




  updateBrand(customeRow: any) {
    this.router.navigateByUrl('maintenance/customersUpdate/' + customeRow.id);
  }


  Detail(customeRow: any) {
    this.router.navigateByUrl('maintenance/customersDetail/' + customeRow.id);
  }


  sendBrand() {
    this.submitted = true;
    if (!this.myForm.invalid) {
      swal({
        title: 'Validando información ...',
        allowOutsideClick: false
      });
      swal.showLoading();

      let statusTemp = 0;
      if (this.enabledUpdated === true) {
        statusTemp = 0;
      } else {
        statusTemp = 1;
      }
      this.restService.createBrand(this.myForm.get('description').value.toUpperCase(), statusTemp).then(data => {
        const resp: any = data;
        if (resp.success === false) {
          swal({
            title: 'Esta marca ya esta registrada',
            text: 'Esta marca no se puede registrar',
            type: 'error'
          });
        } else {
          this.myForm.get('description').setValue('');
          document.getElementById('createBrandHide').click();
          this.loadingData();
          swal({
            title: 'Marca agregada',
            type: 'success'
          });
        }
      }).catch(error => {
        console.log(error);
      });
    }
  }


  sendCustomer() {
    this.router.navigateByUrl('/maintenance/registerCustomer');
  }


  sendUpdateBrand() {

    this.submitted = true;
    if (!this.myFormUpdate.invalid) {
      swal({
        title: 'Validando información ...',
        allowOutsideClick: false
      });
      swal.showLoading();

      let statusTemp = 1;
      if (this.enabledUpdated === true) {
        statusTemp = 0;
      } else {
        statusTemp = 1;
      }
      this.restService.updateBrand(Number(this.currentBrand.id), this.myFormUpdate.get('descriptionUpdate').value.toUpperCase(), statusTemp)
        .then(data => {
          const resp: any = data;
          if (resp.success === false) {
            swal({
              title: 'Esta marca ya esta actualizada',
              text: 'Esta marca no se puede actualizar',
              type: 'error'
            });
          } else {
            document.getElementById('updateBrandHide').click();
            this.loadingData();
            swal({
              title: 'Marca actualizada',
              type: 'success'
            });
          }
        }).catch(error => {
          console.log(error);
        });
    }
  }

  get checkForm() { return this.myForm.controls; }
  get checkFormUpdate() { return this.myFormUpdate.controls; }


  deleteCustomer(brand: any) {
    swal({
      title: 'Estás seguro de eliminar este elemento?',
      type: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'No',
      confirmButtonText: 'Si'

    })
      .then((willDelete) => {
        if (willDelete.value) {
          this.elementDelete = brand;
          this.askDeleteReason();
        } else {
          // swal('Fail');
        }
      });
  }

  askDeleteReason() {
    swal({
      title: 'Razón de la eliminación',
      text: 'Ingrese la razón de la eliminación del cliente (máximo 255 caracteres).',
      input: 'textarea',
      inputPlaceholder: 'Ingrese la razón...',
      inputAttributes: {
        maxlength: '255'
      },
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: false,
      inputValidator: (value) => {
        if (!value || !value.trim()) {
          return 'La razón es obligatoria';
        }
        if (value.length > 255) {
          return 'La razón no puede superar los 255 caracteres';
        }
      }
    }).then((result) => {
      if (result.value) {
        this.executeDeleteCustomer(result.value.trim());
      }
    });
  }

  executeDeleteCustomer(reason: string) {
    swal({
      title: 'Validando información ...',
      allowOutsideClick: false
    });
    swal.showLoading();
    this.restService.deleteCustomer(Number(this.elementDelete.id), this.userId, reason)
      .then(data => {
        swal.showLoading();
        const resp: any = data;

        if (resp.success === false) {
          swal({
            title: 'Este cliente presenta problemas',
            text: 'Este cliente no se puede eliminar',
            type: 'error'
          });
        } else {
          // this.router.navigateByUrl('master/registerBrand');
          this.loadingData();
          swal({
            title: 'Cliente eliminado',
            type: 'success'
          });
        }
      }).catch(error => {
        console.log(error);
      });
  }

  ngOnInit() {
  }

  blockAgents(vadr: any) {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/master-customers/master-customers.component.ts